import { useTranslation } from 'react-i18next';
import React from 'react';
import Popup from '../Atoms/Popup';
import H2 from '../Atoms/H2';
import * as api from '../../api';
import BlueButton from '../Atoms/BlueButton';
import Spinner from '../../Plateforme/Atoms/Spinner';

const PaymentPopup = (props) => {

    const { i18n } = useTranslation('common');

    return (
        <Popup close={props.close}>
            {props.title && <><H2>{props.title}</H2><br/></>}
            <p>
                {i18n.language === 'fr' ? "Pour accèder à nos services exclusifs, vous devez payer les frais d'adhésion à la communauté." : "To access our exclusive services, you must pay the membership fee to the community."}<br/><br/>
                <strong className='centered'>{props.email}</strong><br/><br/>
                <a href="https://www.lefrenchdesign.org/produits/p/espace-membres" className='centered' target='_blank' rel='noreferrer'>{i18n.language === 'fr' ? "Payer maintenant" : "Pay now"}</a><br/><br/>
                <i className='centered'>{i18n.language === 'fr' ? "Si vous venez de payer, veuillez recharger la page." : "If you have just paid, please reload the page."}</i>
            </p>
        </Popup>
    );
}

const PaymentPopupV2 = (props) => {

    const { i18n } = useTranslation('common');
    const [paymentSessionLoading, setPaymentSessionLoading] = React.useState(false);

    function payOnplatform() {
        setPaymentSessionLoading(true);
        const currentUrl = window.location.href;
        api.CreatePaymentSession(encodeURIComponent(currentUrl)).then((response) => {
            window.location.href = response.data;
        }).catch((error) => {
            console.log(error);            
            api.LogFront("Error in PaymentPopup.js payOnplatform: " + error);
            if(error.response && error.response.data === "user_is_admin_or_jury") {
                alert(i18n.language === 'fr' ? "Vous ne pouvez pas accéder au paiement car vous êtes un administrateur ou un membre du jury." : "You cannot access the payment because you are an administrator or a jury member.");
            }else if(error.response && error.response.data === "missing_hs_profile") {
                const msg = i18n.language === 'fr'
                    ? "Veuillez d'abord compléter votre profil avant de procéder au paiement."
                    : "Please complete your profile before proceeding to payment.";
                if(window.confirm(msg)) {
                    window.location.href = '/myprofile';
                }
            }else {
                alert(i18n.language === 'fr' ? "Une erreur est survenue." : "An error occurred.");
            }
            setPaymentSessionLoading(false);
        });
    }

    return (
        <Popup close={props.close}>
            {props.title && <><H2>{props.title}</H2><br/></>}
            <p>
                {i18n.language === 'fr' ? "Pour accèder à nos services exclusifs, vous devez payer les frais d'adhésion à la communauté." : "To access our exclusive services, you must pay the membership fee to the community."}<br/><br/>
                {paymentSessionLoading ? 
                    <Spinner/> : 
                    <BlueButton onClick={payOnplatform} className='centered'>{i18n.language === 'fr' ? "Accéder au paiement" : "Access payment"}</BlueButton>
                }
            </p>
        </Popup>
    );
}

export default PaymentPopup;

export { PaymentPopupV2 };
